export default {"src":"/_next/static/media/Menu-Button.a0285d40.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};